export const getRPMModelId = (url: string) => {
  return url
    .substring(url.lastIndexOf('/') + 1)
    .split('.glb')
    .at(0);
};
